module.exports = __webpack_public_path__ + "img/icon-jpg.ff87da41.png";